import styled from 'styled-components'

import Description from '../../components/Description/Description'
import Title from '../../components/Title/Title'
import NewsletterSubscribe from '../../components/NewsletterSubscribe/NewsletterSubscribe'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
  justify-items: center;
`

export default function Newsletter() {
  return (
    <Container>
      <div className="container">
        <Wrapper>
          <Grid1>
            <Title title="Subscribe" />
            <Description description="For the future updates!" />
            <NewsletterSubscribe />
          </Grid1>
        </Wrapper>
      </div>
    </Container>
  )
}
